/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { resetFilters, setFilter, setPagination } from "..";

type FiltersKey =
  | "search"
  | "type_request"
  | "type_solicitation"
  | "created_at"
  | "meta";

export const useFilterEngineAction = () => {
  const dispatch = useDispatch();

  const updateFilter = (key: FiltersKey, value: any) => {
    dispatch(setFilter({ key, value }));
  };
  const clearFilters = () => {
    dispatch(resetFilters());
  };
  const updatePagination = (page: number, perPage: number) => {
    dispatch(setPagination({ page, perPage }));
  };

  return { updateFilter, clearFilters, updatePagination };
};
